<template>
  <div id="SysLogSetting">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="sysSetting">
      <h1>系统设置</h1>
      <div class="setting">
        <el-switch style="display: block;width:280px;" class="eb-switch" v-model="operLogRecordStatus" active-color="#13ce66" active-text="已记录操作日志" inactive-text="未记录操作日志" active-value="1" inactive-value="0" @change="setOperLogStatus"></el-switch>
        <el-switch style="display: block;margin-top:15px;width:280px;" class="eb-switch" v-model="wxPayStatus" active-color="#13ce66" active-text="开启微信支付" inactive-text="关闭微信支付" active-value="1" inactive-value="0" @change="setWxPayStatusChange"></el-switch>
      </div>
    </div>
    <div class="userLogSetting">
      <div class="left">
        <h1>用户记录日志设置</h1>
      </div>
      <div class="right">
        <eb-search @search-click="searchData" slot="search" placeholder="请输入用户名、姓名、机构名称" />
      </div>
    </div>
    <div class="table eb-table">
      <el-table :data.sync="pageData" tooltip-effect="dark" style="width: 100%" @sort-change="sortChange">
        <el-table-column prop='showName' label="用户名" width="100" sortable='custom'></el-table-column>
        <el-table-column prop='trueName' label="姓名" width="100" sortable='custom'></el-table-column>
        <el-table-column prop='orgName' label="机构名称" sortable='custom' min-width="150"></el-table-column>
        <el-table-column prop='userPhone' label="手机" width="120" sortable='custom'></el-table-column>
        <el-table-column prop='userEmail' label="邮件" sortable='custom' min-width="130"></el-table-column>
        <el-table-column prop='status' label="状态" width="100" sortable='custom'>
          <template slot-scope="scope">
            {{userStatus(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column prop='isRecordLog' label="是否记录日志" width="130">
          <template slot-scope="scope">
            <el-switch style="display: block" v-model="scope.row.isRecordLog" active-color="#13ce66" active-value="1" inactive-value="0" @change="setUserLogStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <eb-pagination :current-page.sync="listRequestData.start" v-if="recordsTotal" @current-change="paginationData" :total="recordsTotal" />
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { getUserInfoList } from '@/services/user/user-service';
import {
  loadAllConfigItems,
  setUserRecordLogStatus,
  setOperLogRecordStatus,
  setWxPayStatus
} from '@/services/system-service';
export default {
  name: 'SysLogSetting',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebPagination
  },
  data() {
    return {
      loading: true,
      pageData: [],
      recordsTotal: null,
      listRequestData: {
        start: 1,
        length: 10,
        content: '',
        orderProp: 'userId',
        orderType: 'asc',
        inStatus: '0,1'
      },
      operLogRecordStatus: '',
      wxPayStatus: '',
      isRed: true
    };
  },
  created() {
    this.initSysLogSetting();
  },
  methods: {
    async initSysLogSetting() {
      this.$root.layout.isLoading = true;
      try {
        let [{ data: data1 }, { data: data2 }] = await Promise.all([
          loadAllConfigItems(),
          getUserInfoList(this.listRequestData)
        ]);
        if (data1.returnCode === '01') {
          this.operLogRecordStatus = data1.data.operLogRecordStatus + '';
          this.wxPayStatus = data1.data.wxPayStatus;
        } else {
          this.$message.error('加载所有设置项失败！');
        }
        if (data2.returnCode === '01') {
          this.pageData = data2.data;
          this.recordsTotal = data2.recordsTotal;
        } else {
          this.$message.error('查询用户信息失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    },
    userStatus: function(status) {
      return this.$options.filters['userStatus'](status);
    },
    // 点击搜索
    searchData: function(searchKey) {
      this.listRequestData.content = searchKey;
      this.initSysLogSetting();
    },
    // 分页
    paginationData(pageNum) {
      this.listRequestData.start = pageNum;
      this.initSysLogSetting();
    },
    sortChange(columnData) {
      this.listRequestData.orderProp = columnData.prop;
      switch (columnData.order) {
        case 'descending':
          this.listRequestData.orderType = 'desc';
          break;
        case 'ascending':
          this.listRequestData.orderType = 'asc';
          break;
      }
      this.initSysLogSetting();
    },
    async setUserLogStatus(row) {
      let params = {
        userId: row.userId,
        isRecordLog: row.isRecordLog
      };
      try {
        let { data } = await setUserRecordLogStatus(params);
        if (data.returnCode === '01') {
          this.$message.success('设置成功');
        } else {
          this.$message.error('设置失败！');
          row.isRecordLog = '0';
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    async setOperLogStatus(status) {
      let params = {
        operLogRecordStatus: status
      };
      try {
        let { data } = await setOperLogRecordStatus(params);
        if (data.returnCode === '01') {
          this.$message.success('设置成功');
        } else {
          this.$message.error('设置失败！');
          this.operLogRecordStatus = '0';
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    async setWxPayStatusChange(status) {
      let params = {
        wxPayStatus: status
      };
      try {
        let { data } = await setWxPayStatus(params);
        if (data.returnCode === '01') {
          this.$message.success('设置成功');
        } else {
          this.$message.error('设置失败！');
          this.wxPayStatus = '0';
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    }
  }
};
</script>
<style lang="less" scoped>
#SysLogSetting {
  .sysSetting {
    width: 100%;
    margin-left: 30px;
    .setting {
      margin-left: 50px;
    }
  }
  .userLogSetting {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .left {
      width: 30%;
      margin-left: 30px;
    }
    .right {
      width: 66%;
      height: 30px;
      margin-top: 20px;
    }
  }
  .table {
    padding: 10px 10px;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
</style>
